import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuthStore, isValidToken } from '../../stores/authStore';

/**
 * 路由守卫组件
 * 用于保护需要登录才能访问的路由
 * 如果没有 token 或 token 不合法，强制跳转到登录页面
 */
export default function ProtectedRoute() {
  const location = useLocation();
  const { token, isAuthenticated } = useAuthStore();

  // 检查用户是否已认证且 token 有效
  const isAuthValid = isAuthenticated && isValidToken(token);

  if (!isAuthValid) {
    // 未登录或 token 无效，重定向到登录页面
    // 保存当前尝试访问的地址，登录后可以跳转回来
    return <Navigate to="/login" state={{ from: location.pathname + location.search }} replace />;
  }

  // 已认证，渲染子路由
  return <Outlet />;
}
